<div class="d-flex flex-column" style="min-height: calc(100vh - 180px);">
  <div>
    <div class="page-title-container">
      <h3 class="mat-card-title-custom">
        {{ 'digital_lot.add_lot_title' | translate }}
      </h3>
    </div>

    <mat-card class="mb-3 pt-3">
      <div class="steps-title mt-3" style="background-color: #fff; padding: 24px 15% !important; border-radius: 4px; border: 1px solid #e0e0e0;">
        <nz-steps [nzCurrent]="0" class="mb-3">
          <nz-step [nzTitle]="titleStep1">
            <ng-template #titleStep1>{{ 'digital_lot.step_upload_pdf' | translate }}</ng-template>
          </nz-step>
          <nz-step [nzTitle]="titleStep2">
            <ng-template #titleStep2>{{ 'digital_lot.step_upload_excel' | translate }}</ng-template>
          </nz-step>
        </nz-steps>
      </div>
    </mat-card>

    <mat-card class="main-content-card" style="margin-bottom: 70px;">
      <mat-card-content class="mb-3 mat-card-content-contract-sm pt-3" style="padding-top: 0px !important;">

        <mat-accordion #accordion="matAccordion" [multi]="true">
          <!-- Step 1: Upload PDF -->
          <mat-expansion-panel [expanded]="true" class="mb-3 mt-3">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title">
                {{ 'digital_lot.upload_pdf_title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            
            <div class="row">
              <div class="col-12 mb-2">
                <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'digital_lot.upload_data' | translate }} <span style="color: red;">*</span></span>
              </div>
              <div class="col-12">
                <div class="drd-container upload-area" (click)="uploadFile()" 
                     (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" 
                     [class.drag-over]="isDragOver">
                  <input type="file" id="filePdf" name="filePdf" style="display: none" (change)="onChangeFile($event)" accept=".pdf" multiple onclick="this.value = null" />
                  
                  <div class="text-center">
                    <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #999;">cloud_upload</mat-icon>
                    <div class="mt-2 mb-2">
                      <span style="color: #ee0033; font-weight: bold;">{{ 'digital_lot.upload' | translate }}</span> {{ 'digital_lot.or_drag_document' | translate }}
                    </div>
                    <div style="font-size: 12px; color: #8F8F8F;">
                      {{ 'digital_lot.pdf_upload_hint_1' | translate }}<br>
                      {{ 'digital_lot.pdf_upload_hint_2' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Step 2: List of uploaded files (only shows when there are files) -->
          <mat-expansion-panel [expanded]="true" class="mb-3" *ngIf="uploadedFiles.data.length > 0">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title d-flex justify-content-between align-items-center" style="width: 100%;">
                <span>{{ 'digital_lot.pdf_list_uploaded' | translate }} <span style="color: red;">({{ uploadedFiles.data.length }})</span></span>
                <div class="d-flex align-items-center" style="font-size: 14px;">
                  <span class="badge badge-secondary mr-2" style="font-size: 14px; font-weight: 400; border-radius: 16px; background-color: #F0F1F2; color: #3B3F46; padding: 5px 10px;">{{ 'digital_lot.total_files' | translate }}: {{ uploadedFiles.data.length }}</span>
                  <span class="badge badge-primary mr-2" style="font-size: 14px; font-weight: 400; border-radius: 16px; background-color: #E8F1FF; color: #1054B5; padding: 5px 10px;">{{ 'digital_lot.success' | translate }}: {{ totalSuccess }}</span>
                  <span class="badge badge-danger" style="font-size: 14px;font-weight: 400; border-radius: 16px; background-color: #FDE6EB; color: #A90024; padding: 5px 10px;">{{ 'digital_lot.failed' | translate }}: {{ totalFailed }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="mat-table-container uploaded-files-table mt-3">
              <mat-table [dataSource]="uploadedFiles" class="mat-table-col-extra-sm">
                <!-- STT -->
                <ng-container matColumnDef="stt">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{ 'digital_lot.stt' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element; let index = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{ index + 1 }}
                  </mat-cell>
                </ng-container>

                <!-- Tên file PDF -->
                <ng-container matColumnDef="fileName">
                  <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                    {{ 'digital_lot.pdf_file_name' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom">
                    <span class="fix-width" [matTooltip]="element.fileName">{{ element.fileName }}</span>
                  </mat-cell>
                </ng-container>

                <!-- Mã ID file hợp đồng -->
                <ng-container matColumnDef="idFileContract">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    {{ 'digital_lot.contract_file_id' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center">
                    <span class="fix-width" [matTooltip]="element.idFileContract">{{ element.idFileContract }}</span>
                  </mat-cell>
                </ng-container>

                <!-- Kết quả upload -->
                <ng-container matColumnDef="uploadStatus">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    {{ 'digital_lot.upload_result' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center">
                    <nz-tag *ngIf="element.uploadStatus === 'SUCCESS'" [nzColor]="'green'" style="margin-right: 0px;">
                      {{ 'digital_lot.success' | translate }}
                    </nz-tag>
                    <nz-tag *ngIf="element.uploadStatus !== 'SUCCESS'" [nzColor]="'red'" style="margin-right: 0px;">
                      {{ 'digital_lot.failed' | translate }}
                    </nz-tag>
                  </mat-cell>
                </ng-container>

                <!-- Thông báo lỗi -->
                <ng-container matColumnDef="errorMessage">
                  <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
                    {{ 'digital_lot.error_message' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom">
                    <span class="fix-width" style="color: #ee0033;" *ngIf="element.errorMessage" [matTooltip]="element.errorMessage">{{ element.errorMessage }}</span>
                  </mat-cell>
                </ng-container>

                <!-- Tác động -->
                <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    {{ 'digital_lot.action' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element; let index = index" class="mat-cell-non-boder-right-bottom number-cell-center">
                    <button mat-icon-button [matMenuTriggerFor]="deleteMenu" #menuTrigger="matMenuTrigger">
                      <i aria-hidden="true" class="fa fa-trash" style="color: #ee0033;" matTooltip="{{ 'digital_lot.delete' | translate }}"></i>
                    </button>
                    <mat-menu #deleteMenu="matMenu" class="custom-delete-menu">
                      <div (click)="$event.stopPropagation()" style="padding: 10px; min-width: 280px;">
                        <div style="display: flex; align-items: center; margin-bottom: 15px;">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="#ee0033" style="margin-right: 8px; flex-shrink: 0;">
                            <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"/>
                          </svg>
                          <span style="font-size: 14px; color: #000000DE;">{{ 'digital_lot.confirm_delete_file' | translate }}</span>
                        </div>
                        <div style="display: flex; justify-content: flex-end;">
                          <button mat-button class="btn-cancel" (click)="menuTrigger.closeMenu()">{{ 'digital_lot.cancel' | translate }}</button>
                          <button mat-raised-button class="btn-confirm" (click)="deleteFile(index, element); menuTrigger.closeMenu()">{{ 'digital_lot.delete' | translate }}</button>
                        </div>
                      </div>
                    </mat-menu>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row" matRipple></mat-row>
              </mat-table>
            </div>
          </mat-expansion-panel>

          <div class="pr-0 fixed-bottom">
            <div class="bg-white text-center mat-elevation-z0 py-2 w-100" style="height: 60px">
              <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button" (click)="onCancel()">
                <mat-icon class="mr-0">cancel</mat-icon>
                {{ "button.cancel" | translate }}
              </button>
              <button mat-raised-button color="primary" class="mr-3" type="button" (click)="onContinue()" [disabled]="totalSuccess === 0">
                <mat-icon class="mr-0">send</mat-icon>
                {{ "button.continue" | translate }}
              </button>
            </div>
          </div>
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  </div>
  
</div>